import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, Validators} from '@angular/forms';
import { UserModel } from 'src/app/components/security/users/models/userModel';
import { environment } from 'src/environments/environment';
import { RestAPIService } from 'src/app/services/restapi.service';
import { ToastService } from 'src/app/services/toaster.service';
import { RoleModel } from '../../roles/models/roleModel';

@Component({
  selector: 'app-users-addedit',
  templateUrl: './addedituser.component.html'
})
export class AddEditUsersComponent {
    submitted: boolean = false;
    user: UserModel = new UserModel();
    //isPasswordVisible: boolean = true;
    //password = new FormControl('', [Validators.required]);
    firstName = new FormControl('', [Validators.required]);
    lastName = new FormControl('', [Validators.required]);
    email = new FormControl('', [Validators.required, Validators.email]);
    role = new FormControl('', [Validators.required]);
    selectedRole: string = '';
    roleList: RoleModel[] = [];
    currentUserIsOwner: boolean = false;

    constructor(
        public _restAPI: RestAPIService, private toast: ToastService,
        public dialogRef: MatDialogRef<AddEditUsersComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
            let userData: UserModel = data.userModel;
            this.currentUserIsOwner = data.isOwner;
            this._restAPI.loading  = false;
            this.user = JSON.parse(JSON.stringify(userData));
            this.selectedRole = JSON.parse(JSON.stringify(userData)).roleId;
            if(JSON.parse(JSON.stringify(userData)).role != undefined && JSON.parse(JSON.stringify(userData)).role.toLowerCase() == 'owner'){
                this.role.disable();
            }
            localStorage["applyUserFilterValue"] = 'true';
        }

    async ngOnInit() {
        this.getRoleList();
        if (this.user.id) {
            if(!this.currentUserIsOwner){
                this.email.disable();
            }
            //this.isPasswordVisible = false;
            const tokenDatajson = localStorage.getItem('token_data');
            if(tokenDatajson) {
                if(JSON.parse(tokenDatajson).email == this.user.email)
                    this.role.disable();
            }
        }
    }

    closeDialog(): void {
      this.dialogRef.close(false);
    }

    async getRoleList() {
        this._restAPI.loading  = true;
        this._restAPI.get<RoleModel[]>(environment.apiURL + 'api/role/list').subscribe({
            next: (data) => {
                this._restAPI.loading  = false;
                this.roleList = data.sort((a: { name: string; }, b: { name: string; }) => a.name.localeCompare(b.name));
            },
            error: (error) => {this._restAPI.loading  = false;this.toast.error(error)}
        });
    }

    async saveUser() {
      if(!this.firstName.invalid && !this.lastName.invalid && !this.email.invalid && !this.role.invalid){
          this._restAPI.loading  = true;
          if (this.user.id != null && this.user.id.length > 0) {
              let postData = {
                  firstName: this.user.firstName,
                  lastName: this.user.lastName,
                  email: this.currentUserIsOwner? this.user.email : null,
                  //roleId: this.selectedRole
              };
              this._restAPI.put<string>(environment.apiURL + 'api/usermanagement/edit/' + this.user.id, postData).subscribe({
                  next: (results) => {
                    this.saveUserRole(results, false);
                  },
                  error: (error) => {this._restAPI.loading  = false;this.toast.error(error)}
              });
          }
          else {
              let postData = {
                firstName: this.user.firstName,
                lastName: this.user.lastName,
                email: this.user.email,
                //roleId: this.selectedRole
              };

              this._restAPI.post<string>(environment.apiURL + 'api/usermanagement/add', postData).subscribe({
                  next: (results) => {
                    this.saveUserRole(results, true);
                  },
                  error: (error) => {this._restAPI.loading  = false;this.toast.error(error)}
              });
          }
      }
    }

    async saveUserRole(userId: string, isAdd: boolean) {
        let postData = [{
            id: '00000000-0000-0000-0000-000000000000',
            userId: userId,
            roleId: this.selectedRole
        }];
        this._restAPI.put<string>(environment.apiURL + 'api/userrole/editbyuser/' + userId, postData).subscribe({
            next: (results) => {
                this._restAPI.loading  = false;
                this.dialogRef.close(true);
                if(isAdd) {
                    this.toast.show("User has been added successfully");
                }
                else {
                    this.toast.show("User has been updated successfully");
                }
            },
            error: (error) => {this._restAPI.loading  = false;this.toast.error(error)}
        });
    }
}